import { render, staticRenderFns } from "./tableDetails.vue?vue&type=template&id=3fc57f52&scoped=true&"
import script from "./tableDetails.vue?vue&type=script&lang=js&"
export * from "./tableDetails.vue?vue&type=script&lang=js&"
import style0 from "./tableDetails.vue?vue&type=style&index=0&id=3fc57f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc57f52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc57f52')) {
      api.createRecord('3fc57f52', component.options)
    } else {
      api.reload('3fc57f52', component.options)
    }
    module.hot.accept("./tableDetails.vue?vue&type=template&id=3fc57f52&scoped=true&", function () {
      api.rerender('3fc57f52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promotion/components/tableDetails.vue"
export default component.exports